module.exports = __webpack_public_path__ + "img/logo.683b290e.svg";